import { cancelOnboardingDocument } from 'commons/service/bank/onboardingDocuments'
import { WriteHook, useMutationManager } from 'state-manager'

export const useCancelOnboardingDocument: WriteHook<{ appDocusignEnvelopeId: number; cancelReason: string }, void> = (
  opts
) => useMutationManager<{ appDocusignEnvelopeId: number; cancelReason: string }, void>(cancelOnboardingDocument, opts)
